import classNames from 'classnames';
import React from 'react';
import styled, { css } from 'styled-components';
import stickyLeftOffset from '~/components/list-view/stickyLeft';
import { colors } from '~/styles';
import { alignToJustify } from './TableColumn';
import { useTable } from './TableContext';

const Cell = styled.div`
  flex: ${({ column }) => (column?.width ? `0 0 ${column?.width}` : '1')};
  position: relative;
  display: flex;
  align-items: center;
  min-height: 2rem;
  justify-content: ${({ column }) => alignToJustify(column.align)};
  min-width: ${({ column }) => column.minWidth ?? column.width ?? 'auto'};
  padding: ${({ column, padding }) => (padding ? padding : column?.padding ? column.padding : '0.5rem 1rem')};
  text-align: ${({ column }) => column.align};
  font-size: ${({ column }) => column.fontSize ?? '0.875rem'};

  ${({ column, $isLastSticky, $stickyLeft }) =>
    !!column?.sticky &&
    css`
      position: sticky;
      left: ${$stickyLeft};
      z-index: 1;
      ${
        $isLastSticky
          ? css`
            background: linear-gradient(to right, ${colors.white} 90%, transparent 100%);
            background-size: calc(100%) calc(100% - 2px);
            background-position: center;
            background-repeat: no-repeat;
          `
          : css`
            background: ${colors.white};
          `
      }
    `}
`;

function TableCell({ className, children, index, ...props }) {
  const table = useTable();
  const column = table.columns[index];
  const lastStickyIndex = table.columns.reduce((last, col, i) => (col?.sticky && col?.isVisible ? i : last), -1);
  const isLastSticky = column?.sticky && index === lastStickyIndex;
  const stickyLeft = stickyLeftOffset(table.columns, index) ?? '0';

  if (!column?.isVisible) return null;
  return (
    <Cell
      {...props}
      column={column}
      $isLastSticky={isLastSticky}
      $stickyLeft={stickyLeft}
      className={classNames(className, 'table-cell', {
        [`cell-${column?.name}`]: column?.name,
      })}>
      {children}
    </Cell>
  );
}

export default styled(TableCell)``;
